/* tslint:disable */
/* eslint-disable */
/**
 * Kubernetes
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: unversioned
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IoK8sApiCoreV1AffinityFromJSON, IoK8sApiCoreV1AffinityToJSON, } from './IoK8sApiCoreV1Affinity';
import { IoK8sApiCoreV1ContainerFromJSON, IoK8sApiCoreV1ContainerToJSON, } from './IoK8sApiCoreV1Container';
import { IoK8sApiCoreV1EphemeralContainerFromJSON, IoK8sApiCoreV1EphemeralContainerToJSON, } from './IoK8sApiCoreV1EphemeralContainer';
import { IoK8sApiCoreV1HostAliasFromJSON, IoK8sApiCoreV1HostAliasToJSON, } from './IoK8sApiCoreV1HostAlias';
import { IoK8sApiCoreV1LocalObjectReferenceFromJSON, IoK8sApiCoreV1LocalObjectReferenceToJSON, } from './IoK8sApiCoreV1LocalObjectReference';
import { IoK8sApiCoreV1PodDNSConfigFromJSON, IoK8sApiCoreV1PodDNSConfigToJSON, } from './IoK8sApiCoreV1PodDNSConfig';
import { IoK8sApiCoreV1PodOSFromJSON, IoK8sApiCoreV1PodOSToJSON, } from './IoK8sApiCoreV1PodOS';
import { IoK8sApiCoreV1PodReadinessGateFromJSON, IoK8sApiCoreV1PodReadinessGateToJSON, } from './IoK8sApiCoreV1PodReadinessGate';
import { IoK8sApiCoreV1PodSecurityContextFromJSON, IoK8sApiCoreV1PodSecurityContextToJSON, } from './IoK8sApiCoreV1PodSecurityContext';
import { IoK8sApiCoreV1TolerationFromJSON, IoK8sApiCoreV1TolerationToJSON, } from './IoK8sApiCoreV1Toleration';
import { IoK8sApiCoreV1TopologySpreadConstraintFromJSON, IoK8sApiCoreV1TopologySpreadConstraintToJSON, } from './IoK8sApiCoreV1TopologySpreadConstraint';
import { IoK8sApiCoreV1VolumeFromJSON, IoK8sApiCoreV1VolumeToJSON, } from './IoK8sApiCoreV1Volume';
/**
 * Check if a given object implements the IoK8sApiCoreV1PodSpec interface.
 */
export function instanceOfIoK8sApiCoreV1PodSpec(value) {
    let isInstance = true;
    isInstance = isInstance && "containers" in value;
    return isInstance;
}
export function IoK8sApiCoreV1PodSpecFromJSON(json) {
    return IoK8sApiCoreV1PodSpecFromJSONTyped(json, false);
}
export function IoK8sApiCoreV1PodSpecFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'activeDeadlineSeconds': !exists(json, 'activeDeadlineSeconds') ? undefined : json['activeDeadlineSeconds'],
        'affinity': !exists(json, 'affinity') ? undefined : IoK8sApiCoreV1AffinityFromJSON(json['affinity']),
        'automountServiceAccountToken': !exists(json, 'automountServiceAccountToken') ? undefined : json['automountServiceAccountToken'],
        'containers': (json['containers'].map(IoK8sApiCoreV1ContainerFromJSON)),
        'dnsConfig': !exists(json, 'dnsConfig') ? undefined : IoK8sApiCoreV1PodDNSConfigFromJSON(json['dnsConfig']),
        'dnsPolicy': !exists(json, 'dnsPolicy') ? undefined : json['dnsPolicy'],
        'enableServiceLinks': !exists(json, 'enableServiceLinks') ? undefined : json['enableServiceLinks'],
        'ephemeralContainers': !exists(json, 'ephemeralContainers') ? undefined : (json['ephemeralContainers'].map(IoK8sApiCoreV1EphemeralContainerFromJSON)),
        'hostAliases': !exists(json, 'hostAliases') ? undefined : (json['hostAliases'].map(IoK8sApiCoreV1HostAliasFromJSON)),
        'hostIPC': !exists(json, 'hostIPC') ? undefined : json['hostIPC'],
        'hostNetwork': !exists(json, 'hostNetwork') ? undefined : json['hostNetwork'],
        'hostPID': !exists(json, 'hostPID') ? undefined : json['hostPID'],
        'hostUsers': !exists(json, 'hostUsers') ? undefined : json['hostUsers'],
        'hostname': !exists(json, 'hostname') ? undefined : json['hostname'],
        'imagePullSecrets': !exists(json, 'imagePullSecrets') ? undefined : (json['imagePullSecrets'].map(IoK8sApiCoreV1LocalObjectReferenceFromJSON)),
        'initContainers': !exists(json, 'initContainers') ? undefined : (json['initContainers'].map(IoK8sApiCoreV1ContainerFromJSON)),
        'nodeName': !exists(json, 'nodeName') ? undefined : json['nodeName'],
        'nodeSelector': !exists(json, 'nodeSelector') ? undefined : json['nodeSelector'],
        'os': !exists(json, 'os') ? undefined : IoK8sApiCoreV1PodOSFromJSON(json['os']),
        'overhead': !exists(json, 'overhead') ? undefined : json['overhead'],
        'preemptionPolicy': !exists(json, 'preemptionPolicy') ? undefined : json['preemptionPolicy'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'priorityClassName': !exists(json, 'priorityClassName') ? undefined : json['priorityClassName'],
        'readinessGates': !exists(json, 'readinessGates') ? undefined : (json['readinessGates'].map(IoK8sApiCoreV1PodReadinessGateFromJSON)),
        'restartPolicy': !exists(json, 'restartPolicy') ? undefined : json['restartPolicy'],
        'runtimeClassName': !exists(json, 'runtimeClassName') ? undefined : json['runtimeClassName'],
        'schedulerName': !exists(json, 'schedulerName') ? undefined : json['schedulerName'],
        'securityContext': !exists(json, 'securityContext') ? undefined : IoK8sApiCoreV1PodSecurityContextFromJSON(json['securityContext']),
        'serviceAccount': !exists(json, 'serviceAccount') ? undefined : json['serviceAccount'],
        'serviceAccountName': !exists(json, 'serviceAccountName') ? undefined : json['serviceAccountName'],
        'setHostnameAsFQDN': !exists(json, 'setHostnameAsFQDN') ? undefined : json['setHostnameAsFQDN'],
        'shareProcessNamespace': !exists(json, 'shareProcessNamespace') ? undefined : json['shareProcessNamespace'],
        'subdomain': !exists(json, 'subdomain') ? undefined : json['subdomain'],
        'terminationGracePeriodSeconds': !exists(json, 'terminationGracePeriodSeconds') ? undefined : json['terminationGracePeriodSeconds'],
        'tolerations': !exists(json, 'tolerations') ? undefined : (json['tolerations'].map(IoK8sApiCoreV1TolerationFromJSON)),
        'topologySpreadConstraints': !exists(json, 'topologySpreadConstraints') ? undefined : (json['topologySpreadConstraints'].map(IoK8sApiCoreV1TopologySpreadConstraintFromJSON)),
        'volumes': !exists(json, 'volumes') ? undefined : (json['volumes'].map(IoK8sApiCoreV1VolumeFromJSON)),
    };
}
export function IoK8sApiCoreV1PodSpecToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'activeDeadlineSeconds': value.activeDeadlineSeconds,
        'affinity': IoK8sApiCoreV1AffinityToJSON(value.affinity),
        'automountServiceAccountToken': value.automountServiceAccountToken,
        'containers': (value.containers.map(IoK8sApiCoreV1ContainerToJSON)),
        'dnsConfig': IoK8sApiCoreV1PodDNSConfigToJSON(value.dnsConfig),
        'dnsPolicy': value.dnsPolicy,
        'enableServiceLinks': value.enableServiceLinks,
        'ephemeralContainers': value.ephemeralContainers === undefined ? undefined : (value.ephemeralContainers.map(IoK8sApiCoreV1EphemeralContainerToJSON)),
        'hostAliases': value.hostAliases === undefined ? undefined : (value.hostAliases.map(IoK8sApiCoreV1HostAliasToJSON)),
        'hostIPC': value.hostIPC,
        'hostNetwork': value.hostNetwork,
        'hostPID': value.hostPID,
        'hostUsers': value.hostUsers,
        'hostname': value.hostname,
        'imagePullSecrets': value.imagePullSecrets === undefined ? undefined : (value.imagePullSecrets.map(IoK8sApiCoreV1LocalObjectReferenceToJSON)),
        'initContainers': value.initContainers === undefined ? undefined : (value.initContainers.map(IoK8sApiCoreV1ContainerToJSON)),
        'nodeName': value.nodeName,
        'nodeSelector': value.nodeSelector,
        'os': IoK8sApiCoreV1PodOSToJSON(value.os),
        'overhead': value.overhead,
        'preemptionPolicy': value.preemptionPolicy,
        'priority': value.priority,
        'priorityClassName': value.priorityClassName,
        'readinessGates': value.readinessGates === undefined ? undefined : (value.readinessGates.map(IoK8sApiCoreV1PodReadinessGateToJSON)),
        'restartPolicy': value.restartPolicy,
        'runtimeClassName': value.runtimeClassName,
        'schedulerName': value.schedulerName,
        'securityContext': IoK8sApiCoreV1PodSecurityContextToJSON(value.securityContext),
        'serviceAccount': value.serviceAccount,
        'serviceAccountName': value.serviceAccountName,
        'setHostnameAsFQDN': value.setHostnameAsFQDN,
        'shareProcessNamespace': value.shareProcessNamespace,
        'subdomain': value.subdomain,
        'terminationGracePeriodSeconds': value.terminationGracePeriodSeconds,
        'tolerations': value.tolerations === undefined ? undefined : (value.tolerations.map(IoK8sApiCoreV1TolerationToJSON)),
        'topologySpreadConstraints': value.topologySpreadConstraints === undefined ? undefined : (value.topologySpreadConstraints.map(IoK8sApiCoreV1TopologySpreadConstraintToJSON)),
        'volumes': value.volumes === undefined ? undefined : (value.volumes.map(IoK8sApiCoreV1VolumeToJSON)),
    };
}
